import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const getDiagnosisState = (state: RootState) => state.diagnosis;

export const selectDiagnoses = createSelector(
  [getDiagnosisState],
  (diagnosisState) => diagnosisState.diagnoses
);

export const selectLoadingDiagnoses = createSelector(
  [getDiagnosisState],
  (diagnosisState) => diagnosisState.loadingDiagnoses
);

export const selectDiagnosesSearchResults = createSelector(
  [getDiagnosisState],
  (diagnosisState) => diagnosisState.diagnosesSearchResult
);

export const selectLoadingDiagnosesSearchResults = createSelector(
  [getDiagnosisState],
  (diagnosisState) => diagnosisState.loadingSearchDiagnoses
);

export const selectLoadingInsertDiagnoses = createSelector(
  [getDiagnosisState],
  (diagnosisState) => diagnosisState.loadingInsertDiagnoses
);
